import React from 'react';
import styled from 'styled-components';
import SearchBar from './SearchBar';

// Styled Components for Header
const HeaderContainer = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px 70px;
  background-color: var(--color-container-card-default);
  color: #000;
  width: 100%;
  box-sizing: border-box;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 20;
  @media (max-width: 834px) {
    padding: 8px 12px;
  }
`;

const LeftRightContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-grow: 1;
  gap: 16px;
  min-width: 0;
  
  @media (max-width: 834px) {
    gap: 8px;
    min-width: 0;
  }
`;

const LeftComponent = styled.div`
  display: flex;
  align-items: center;
  min-width: 0;
  flex-shrink: 0;
`;

const RightComponent = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
  flex-shrink: 0;
  
  @media (max-width: 834px) {
    gap: 6px;
  }
`;

const MenuButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  display: none;

  @media (max-width: 834px) {
    display: block;
  }
`;

const MenuIcon = styled.svg`
  width: 20px;
  height: 20px;
`;

const Header = ({ onMenuClick, leftC, rightC }) => (
  <HeaderContainer>
    <LeftRightContainer>

    <MenuButton onClick={onMenuClick}>
        <MenuIcon
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
        </MenuIcon>
      </MenuButton>
      {/* Left component */}
      <LeftComponent>{leftC}</LeftComponent>

      <SearchBar />

      {/* Right component */}
      <RightComponent>{rightC}</RightComponent>
    </LeftRightContainer>
  </HeaderContainer>
);

export default Header;
